export class CLMResponse {
    htmlData:string;
    statusCode:string;
}
